import { OFFICE_CARD_FRAGMENT } from './fragments'

const { gql } = require('graphql-request')

export const CREATE_OFFICE_CARD = gql`
  mutation CreateOfficeCard($input: CreateOfficeCardInput!) {
    createOfficeCard(input: $input) {
      ...officeCardInfo
    }
  }
  ${OFFICE_CARD_FRAGMENT}
`

export const UPDATE_OFFICE_CARD = gql`
  mutation UpdateOfficeCard($id: ID!, $input: UpdateOfficeCardInput!) {
    updateOfficeCard(id: $id, input: $input) {
      ...officeCardInfo
    }
  }
  ${OFFICE_CARD_FRAGMENT}
`

export const DELETE_OFFICE_CARD = gql`
  mutation DeleteOfficeCard($id: ID!) {
    deleteOfficeCard(id: $id)
  }
`

const mutations = {
  CREATE_OFFICE_CARD,
  UPDATE_OFFICE_CARD,
  DELETE_OFFICE_CARD
}

export default mutations 